var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-footer',{attrs:{"color":"primary white--text"}},[_c('v-spacer'),_c('div',[_vm._v("© Fernando Martins - 2020")]),_c('v-spacer')],1)}
var staticRenderFns = []

export { render, staticRenderFns }